import { Row, Col, Alert } from 'react-bootstrap';
import Icon from 'utility/icomoon';

interface Props {
  message: string;
  color?: string;
  icon?: string;
  visible?: boolean;
  className?: string;
  useRowWrapper?: boolean;
}

const SimpleAlertMessage = (props: Props) => {
  const {
    message,
    color = 'warning',
    icon = 'PreventiveNotice',
    visible = true,
    className = '',
    useRowWrapper = true
  } = props;

  if (!visible) return null;

  const alertContent = (
    <Alert variant={color} className={useRowWrapper ? 'mx-1 flex-grow-1' : `w-100 ${className}`}>
      <Row className="px-3 py-1">
        <Icon size={16} icon={icon} className="mr-0" />
        <Col>{message}</Col>
      </Row>
    </Alert>
  );

  if (useRowWrapper) {
    return <Row className={`w-100 d-flex justify-content-center ${className}`}>{alertContent}</Row>;
  }

  return alertContent;
};

export default SimpleAlertMessage;
